import {jsonRpc} from 'communication/src'
import {
  createTemporaryUploadLink,
  createTemporaryDownloadLink,
  deleteTemporarySnapshot,
  createUploadLink,
} from '@/messages'
import useBlob from './useBlob'

export default function useS3Service() {
  const {blobToBase64} = useBlob()

  const uploadToS3 = async (uploadLink, data) => {
    const blob = await (await window.fetch(data)).blob()
    await fetch(uploadLink, {
      method: 'PUT',
      headers: {
        'Content-Type': 'image/jpeg',
      },
      body: blob,
    })
  }

  const getTemporarySnapshotUploadLinks = async () => {
    const {uploadLink, thumbnailUploadLink} = await jsonRpc.sendAndWait(createTemporaryUploadLink())
    return {uploadLink, thumbnailUploadLink}
  }

  const saveSnapshot = async data => {
    const {uploadLink, key, bucket} = await jsonRpc.sendAndWait(createUploadLink())
    await uploadToS3(uploadLink, data)
    return {bucket, key}
  }

  const downloadSnapshot = async thumbnail => {
    const {downloadLink} = await jsonRpc.sendAndWait(createTemporaryDownloadLink(thumbnail))
    const response = await fetch(downloadLink)
    const blob = await response.blob()
    return await blobToBase64(blob)
  }

  const deleteSnapshot = async () => {
    await jsonRpc.sendAndWait(deleteTemporarySnapshot())
  }

  return {
    deleteSnapshot,
    saveSnapshot,
    getTemporarySnapshotUploadLinks,
    uploadToS3,
    downloadSnapshot,
  }
}
